import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import './Header.scss';

export default class Header extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    tooltip: PropTypes.string,
  };
  static defaultProps = {
    tooltip: '',
  };
  render() {
    const { title, tooltip } = this.props;
    return (
      <React.Fragment>
        <a href
          className="nf-solicitation_grid_header-tooltip"
          data-tip={tooltip}
          data-for={`tooltip-${title}`}
        >
          {title}
        </a>
        <ReactTooltip
          id={`tooltip-${title}`}
          type="dark"
          effect="float"
          delayShow={350}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/SolicitationsGrid/subcomponents/Header/Header.jsx